import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CalendarView } from 'angular-calendar';

@Component({
  selector: 'mwl-demo-utils-calendar-header',
  template: `
  <mat-toolbar *ngIf="!mobile" color="#f2f3ed" fxLayout="row" fxLayoutAlign="center center">
  <mat-toolbar-row>
      <div class="logo">
          <div class="col-md-4">
              <h3> </h3>
            </div>
      </div>


      <span class="spacer"></span>

      <div class="logo">
            {{ viewDate | calendarDate: view + 'ViewTitle':locale }}
      </div>

      <span class="spacer"></span>

      <div class="logo">
          <div class="col-md-4">
              <div class="btn-group">
                  <div class="btn btn-outline-secondary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                      < </div>
                          <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                              <mat-icon>today</mat-icon>
                          </div>
                          <div class="btn btn-outline-secondary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)"> > </div>
                  </div>
              </div>
      </div>


  </mat-toolbar-row>

</mat-toolbar>





<mat-toolbar *ngIf="mobile" color="#f2f3ed" fxLayout="row" fxLayoutAlign="center center">
<mat-toolbar-row>

    <span class="spacer"></span>

    <div class="logo2">
          {{ viewDate | calendarDate: view + 'ViewTitle':locale }}
    </div>

    <span class="spacer"></span>

    <div class="logo">
        <div class="col-md-4">
            <div class="btn-group" style=" height: 10vw;">
                <div class="btn btn-outline-secondary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                    < </div>
                        <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)">
                            <mat-icon>today</mat-icon>
                        </div>
                        <div class="btn btn-outline-secondary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="viewDateChange.next(viewDate)"> > </div>
                </div>
            </div>
    </div>


</mat-toolbar-row>

</mat-toolbar>


  `,
  styleUrls: ['./scheduler.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarHeaderComponent {
  @Input() view: CalendarView;

  @Input() public viewDate: Date;

  @Input() locale: string = 'en';

  @Output() viewChange = new EventEmitter<CalendarView>();

  @Output() public viewDateChange = new EventEmitter<Date>();

  CalendarView = CalendarView;
  mobile
  ngOnInit(): void {
    let agent = navigator.userAgent;
    agent = agent.toLowerCase()
    if (agent.includes("android") || agent.includes("iphone")) {
        this.mobile = true
    } else {
        this.mobile = false
    }
  }
}